@if(loading) {
<div class="spinner-container">
  <div class="loading-spinner" id="page-loading-spinner">
    <mat-spinner mode="indeterminate"></mat-spinner>
    <!-- <p>Loading now...</p> -->
  </div>
</div>
}
